module.exports = __webpack_public_path__ + "static/media/get-started-with-citrus.86ed7f1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/StartPages/images/get-started-with-citrus.png
// module id = 263
// module chunks = 1